import config from '../../config';

const styles = {
    page: {
        minHeight: 'calc(100vh - 64px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f5f7fa',
        padding: '2rem',
    },
    card: {
        maxWidth: '700px',
        width: '100%',
        background: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
        padding: '2.5rem',
        textAlign: 'center',
    },
    title: {
        fontSize: '2rem',
        marginBottom: '1rem',
        color: '#1f2937',
    },
    text: {
        fontSize: '1rem',
        color: '#4b5563',
        marginBottom: '2rem',
        lineHeight: '1.5',
    },
    buttonRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '1rem',
        justifyContent: 'center',
        backgroundColor: '#f9fafb',
        padding: '1.5rem',
        borderRadius: '8px',
    },
    button: {
        flex: '1 1 200px',
        padding: '0.75rem 1.5rem',
        color: '#fff',
        borderRadius: '6px',
        textDecoration: 'none',
        fontWeight: '500',
        textAlign: 'center',
        transition: 'background 0.2s ease',
    },
    primaryButton: {
        backgroundColor: '#0070f3',
    },
    secondaryButton: {
        backgroundColor: '#6b7280',
    },
    error: {
        color: '#dc2626',
        marginTop: '1rem',
        fontSize: '0.9rem',
    },
};

const RetirementPage = () => (
    <div style={styles.page}>
        <div style={styles.card}>
            <h1 style={styles.title}>Application Retired</h1>

            <p style={styles.text}>
                This application has been retired and is no longer available.
            </p>

            <p style={styles.text}>
                For more information, you can access Salesforce or explore our
                ProGPT Agents.
            </p>

            <div style={styles.buttonRow}>
                {config?.salesforceUrl ? (
                    <a
                        href={config.salesforceUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ ...styles.button, ...styles.primaryButton }}
                    >
                        Go to Salesforce
                    </a>
                ) : (
                    <p style={styles.error}>
                        Salesforce link is not configured.
                    </p>
                )}

                {config?.iShareUrl && (
                    <a
                        href={config.iShareUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ ...styles.button, ...styles.secondaryButton }}
                    >
                        Explore ProGPT Agents
                    </a>
                )}
            </div>
        </div>
    </div>
);

export default RetirementPage;
